import React from "react";

export default function ProfileImageUpload({ image, onChange, size = 96 }) {
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/webp",
      ];

      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        // Basic feedback; parent can also handle errors if needed
        alert("Only JPEG, PNG, GIF, and WebP images are allowed.");
        return;
      }
      // Pass the file object directly for upload
      // Also create a preview data URL for immediate display
      const reader = new FileReader();
      reader.onload = (ev) => {
        // Call onChange with both the file (for upload) and preview (for display)
        // The parent component can handle both
        onChange(file, ev.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="flex items-center gap-4">
      <label
        className="cursor-pointer group flex flex-col items-center"
        title="Upload profile picture"
        style={{ width: size, height: size }}
      >
        <img
          src={image}
          alt="profile"
          className="object-cover rounded-xl border-2 border-[#4962d8] group-hover:opacity-80 transition"
          style={{ width: size, height: size, objectFit: "cover" }}
          onError={(e) => {
            // Fallback to default avatar if image fails to load
            if (!e.currentTarget.src.includes('cdn-icons-png.flaticon.com')) {
              e.currentTarget.src = "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";
            }
          }}
        />
        <input
          type="file"
          accept="image/*"
          className="hidden"
          onChange={handleFileChange}
        />
        <span className="block text-xs text-[#4962d8] mt-1 opacity-0 group-hover:opacity-100 transition">
          Change Photo
        </span>
      </label>
      <span className="block text-[11px] text-gray-500 leading-tight max-w-[200px]">
        Only JPEG, PNG, GIF, and WebP images are allowed
      </span>
    </div>
  );
} 